// Shared UI primitives ported from Claude Design/app/ui.jsx (ESM-ified).

import React from 'react';

export function VideoThumb({ aspect = '16/10', label, style, className, src }) {
  const bars = 28;
  const heights = [];
  for (let i = 0; i < bars; i++) {
    const v = 0.4 + Math.abs(Math.sin(i * 0.7) * 0.3) + Math.abs(Math.sin(i * 1.4 + 1) * 0.2);
    heights.push(Math.min(1, v));
  }
  return (
    <div className={'video-thumb ' + (className || '')} style={{ aspectRatio: aspect, ...(style || {}) }}>
      {src ? <img src={src} alt="" className="video-thumb-img" /> : null}
      {label && <div className="video-thumb-label">{label}</div>}
      <div className="video-thumb-icon" aria-hidden>
        <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor">
          <path d="M4 3l9 5-9 5V3z" />
        </svg>
      </div>
      {!src && (
        <div className="video-thumb-wave">
          {heights.map((h, i) => <span key={i} style={{ height: (h * 100) + '%' }} />)}
        </div>
      )}
    </div>
  );
}

export const Icons = {
  upload: (
    <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 4v14M6 10l6-6 6 6" />
      <path d="M4 18v2a2 2 0 002 2h12a2 2 0 002-2v-2" />
    </svg>
  ),
  undo: <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7v6h6" /><path d="M21 17a9 9 0 00-15-7l-3 3" /></svg>,
  redo: <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 7v6h-6" /><path d="M3 17a9 9 0 0115-7l3 3" /></svg>,
  play: <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M6 4l14 8-14 8z" /></svg>,
  pause: <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M6 4h4v16H6zM14 4h4v16h-4z" /></svg>,
  next: <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M5 4l10 8-10 8zM17 4h2v16h-2z" /></svg>,
  prev: <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M19 4L9 12l10 8zM5 4h2v16H5z" /></svg>,
  fwd: <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1014-7.5" /><path d="M17 3v5h-5" /></svg>,
  back: <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 11-14-7.5" /><path d="M7 3v5h5" /></svg>,
  scissors: <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="6" cy="6" r="3" /><circle cx="6" cy="18" r="3" /><path d="M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12" /></svg>,
  merge: <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M8 6l-4 6 4 6M16 6l4 6-4 6M4 12h16" /></svg>,
  plus: <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M12 5v14M5 12h14" /></svg>,
  trash: <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2M6 6l1 14a2 2 0 002 2h6a2 2 0 002-2l1-14" /></svg>,
  instagram: (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" stroke="none" />
    </svg>
  ),
  telegram: (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
      <path d="M21.6 3.5L2.8 10.7c-1 .4-1 1.7 0 2l4.7 1.7 1.8 5.8c.3.9 1.4 1 1.9.3l2.6-3 4.7 3.5c.9.6 2.1.2 2.4-.9L23 5.4c.4-1.3-.9-2.3-1.4-1.9zM17.4 8.2l-7.2 6.6-.4 3.5-1.8-5.5 9.4-4.6z" />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
    </svg>
  ),
};

// Status label as colored text (matches StatusLabel in chapters.jsx)
export function StatusLabel({ status }) {
  if (status === 'published') return <span style={{ color: 'var(--ok)' }}>✓ опубликован</span>;
  if (status === 'queued') return <span style={{ color: 'var(--amber)' }}>⏳ в очереди</span>;
  if (status === 'failed') return <span style={{ color: 'var(--err)' }}>✗ ошибка</span>;
  if (status === 'scheduled') return <span style={{ color: 'var(--amber)' }}>⏳ запланирован</span>;
  if (status === 'review') return <span style={{ color: 'var(--amber)' }}>ⓘ ревью</span>;
  if (status === 'processing') return <span style={{ color: 'var(--amber)' }}>● обработка</span>;
  return <span style={{ color: 'var(--ink-mute)' }}>… черновик</span>;
}

// Russian pluralisation
export function ruPlural(n, one, few, many) {
  const m = n % 100;
  if (m > 10 && m < 20) return many;
  const k = n % 10;
  if (k === 1) return one;
  if (k >= 2 && k <= 4) return few;
  return many;
}

// Topic lookup from a store. Pass in the topics array (from useStore).
// Falls back to a slate-coloured default if not found.
const DEFAULT_TOPIC = { id: '_', label: '_', label_ru: '_', hue: 'sage' };
export function findTopic(topics, idOrLabel) {
  if (!Array.isArray(topics) || !topics.length) return { ...DEFAULT_TOPIC, label: idOrLabel || '' };
  const t = topics.find((x) => x.id === idOrLabel || x.label === idOrLabel || x.label_ru === idOrLabel);
  return t || { ...DEFAULT_TOPIC, label: idOrLabel || '' };
}

// HH:MM:SS / MM:SS parser → seconds (or null on bad input)
export function parseClock(s) {
  if (typeof s !== 'string') return null;
  const m = s.trim().match(/^(?:(\d+):)?(\d{1,2}):(\d{1,2}(?:\.\d+)?)$/);
  if (!m) return null;
  return (parseInt(m[1] || 0) * 3600) + (parseInt(m[2]) * 60) + parseFloat(m[3]);
}

export function fmtClock(sec) {
  sec = Math.max(0, Math.round(Number(sec) || 0));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function fmtDur(sec) {
  sec = Math.max(0, Math.round(Number(sec) || 0));
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

// Short M:SS for subtitle row timecodes (whole seconds)
export function fmtT(sec) {
  sec = Math.max(0, Math.round(Number(sec) || 0));
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function parseSubTime(s) {
  if (typeof s !== 'string') return null;
  const m = s.trim().match(/^(\d+):(\d{1,2})$/);
  if (!m) return null;
  return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
}
